<template>
    <v-container>
        <v-card class="soli-round" style="overflow: hidden">
            <v-overlay
                :value="calendarLoading"
                z-index="12"
                opacity="100"
                absolute
                color="white"
            >
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-toolbar flat :class="['schedule-toolbar']">
                <v-row class="align-center justify-around" style="height: 72px">
                    <v-col cols="4" class="flex justify-start">
                        <v-btn
                            :disabled="
                                getTitleDate <=
                                globalMomentYMD(new Date(calendarMin))
                            "
                            :small="$vuetify.breakpoint.smAndDown"
                            icon
                            :elevation="$vuetify.breakpoint.smAndDown ? 2 : 0"
                            @click="prev"
                            ><v-icon color="dark">chevron_left</v-icon></v-btn
                        >
                        <v-btn
                            :disabled="checkCalendarMax"
                            :small="$vuetify.breakpoint.smAndDown"
                            icon
                            :elevation="$vuetify.breakpoint.smAndDown ? 2 : 0"
                            class="ml-1"
                            @click="next"
                            ><v-icon color="dark">chevron_right</v-icon></v-btn
                        ></v-col
                    >

                    <v-col cols="4" class="flex justify-center">
                        <div class="font-bold px-0 soli-grey">
                            {{ getViewTitle }}
                        </div>
                    </v-col>
                    <v-col
                        cols="4"
                        class="justify-end flex"
                        :class="$vuetify.breakpoint.smAndDown ? 'my-2' : null"
                    >
                        <!--<v-btn
                                color="soli-grey"
                                icon
                                :small="$vuetify.breakpoint.smAndDown"
                                :elevation="$vuetify.breakpoint.smAndDown ? 2 : 0"
                                class="mr-1"
                                @click="setToday"
                                ><v-icon color="dark">today</v-icon></v-btn
                                >-->
                        <v-btn
                            v-if="$page.props.auth.user"
                            :small="$vuetify.breakpoint.smAndDown"
                            :elevation="$vuetify.breakpoint.smAndDown ? 2 : 0"
                            icon
                            :class="[
                                'stack-btn',
                                $vuetify.breakpoint.smAndDown ? 'mr-1' : 'mr-3',
                            ]"
                            :ripple="false"
                            @click.stop="
                                [(nearMe = !nearMe), getCalendarEvents()]
                            "
                        >
                            <v-icon :color="nearMe ? 'secondary' : 'dark'"
                                >near_me</v-icon
                            ><small
                                v-if="$vuetify.breakpoint.smAndUp"
                                style="font-size: 8px"
                                class="soli-grey"
                            >
                                Near Me
                            </small></v-btn
                        >
                        <v-btn
                            color="dark"
                            icon
                            :small="$vuetify.breakpoint.smAndDown"
                            :elevation="$vuetify.breakpoint.smAndDown ? 2 : 0"
                            :ripple="false"
                            class="stack-btn"
                            @click="setToday"
                            ><v-icon>today</v-icon
                            ><small
                                v-if="$vuetify.breakpoint.smAndUp"
                                style="font-size: 8px"
                            >
                                Today
                            </small></v-btn
                        >
                    </v-col>
                </v-row>
            </v-toolbar>
            <FullCalendar
                id="fc-allEvents"
                class="fc-allEvents"
                ref="fullCalendar"
                :options="calendarOptions"
            >
                <template v-slot:eventContent="arg">
                    <b class="soli-grey">{{ arg.timeText }} </b>
                    <div class="subtitle-2 font-bold">
                        {{ arg.event.title }}
                    </div>
                    <small class="block" style="line-height: 11px !important">{{
                        `w/ ${arg.event.extendedProps.description}`
                    }}</small>
                    <small>{{
                        `${arg.event.extendedProps.location.name}`
                    }}</small>
                </template>
            </FullCalendar>
        </v-card>
    </v-container>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    components: {
        FullCalendar,
    },
    mixins: [globalMoment],
    props: ["calendarMin", "calendarMax"],
    data() {
        return {
            nearMe: !!this.$page.props.auth.user,
            calendarLoading: false,
            title: null,
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    interactionPlugin,
                    //momentTimezonePlugin,
                    dayGridPlugin,
                ],
                //schedulerLicenseKey:
                //    "CC-Attribution-NonCommercial-NoDerivatives",
                initialView: "dayGridMonth",
                //timeZone: this.$page.props.auth.user ? this.$page.props.auth.user.timezone : 'America/New_York',
                initialDate: new Date(),
                longPressDelay: 500,
                scrollTimeReset: false,
                windowResize: this.handleWindowResize,
                expandRows: true,
                //allDaySlot: false,
                eventClick: this.handleEventClick,
                eventDrop: null,
                select: null,
                eventResize: null,
                eventStartEditable: false,
                eventResizableFromStart: false,
                //selectOverlap: this.getSelectOverlap,
                slotLabelInterval: { hours: 1 },
                selectable: false,
                selectMirror: false,
                selectMinDistance: 0,
                height: !this.$vuetify.breakpoint.smAndDown
                    ? "calc(100vh - 228px)"
                    : "auto",
                stickyHeaderDates: true,
                headerToolbar: false,
                nowIndicator: true,
                editable: false,
                events: [],
                eventSources: [],
                slotMinTime: "06:00:00",
                viewDidMount: this.getTitle,
            },
        };
    },
    methods: {
        getCalendarEvents() {
            this.calendarLoading = true;
            this.calendarOptions.events = [];
            return axios
                .get("/api/lessons/upcoming-group-events", {
                    params: {
                        //title: null,
                        eventId: null,
                        calendarMin: this.calendarMin,
                        calendarMax: this.calendarMax,
                        nearMe: !!this.nearMe
                            ? this.$page.props.auth.user.selected_location
                                  .market_id
                            : null,
                    },
                })
                .then((resp) => {
                    resp.data.map((event) => {
                        this.calendarOptions.events.push({
                            classNames: "fc-lesson soli-round pa-1",
                            location: event.location,
                            title: event.group_event.title,
                            id: event.id,
                            description: `with ${event.teacher.name}`,
                            start: event.starts_at,
                            end: event.ends_at,
                        });
                    });
                    this.$nextTick(() => {
                        this.$refs.fullCalendar.getApi().updateSize();
                    });
                    this.calendarLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handleWindowResize() {
            setTimeout(() => {
                this.$refs.fullCalendar.getApi().updateSize();
            }, 300);
        },
        handleEventClick(arg) {
            arg.event.location = arg.event.extendedProps.location;
            this.$emit("selectClass", arg.event);
            //this.lessonDetails = arg.event
            //this.lessonDetails.room = arg.event.extendedProps.room
            // this.lessonDetails.location = arg.event.extendedProps.room.location
        },
        jumpDate(date) {
            this.calendarOptions.eventSources = [];
            this.$refs.fullCalendar.getApi().gotoDate(date);
            this.getTitle();
            //this.getCalendarEvents();
        },
        setToday() {
            this.$refs.fullCalendar.getApi().today();
            this.getTitle();
            //this.getCalendarEvents();
        },
        prev() {
            this.$refs.fullCalendar.getApi().prev();
            this.getTitle();
            //this.getCalendarEvents();
        },
        next() {
            this.$refs.fullCalendar.getApi().next();
            this.getTitle();
            //this.getCalendarEvents();
        },
        getTitle() {
            this.title = moment(
                this.$refs.fullCalendar.getApi().currentData.currentDate
            ).tz("UTC");
        },
    },
    computed: {
        checkCalendarMax() {
            return (
                this.getTitleDate >=
                moment(new Date(this.calendarMax))
                    .startOf("month")
                    .format("YYYY-MM-DD")
            );
        },
        /*datePicker() {
            let mobile = this.$vuetify.breakpoint.smAndDown;
            return {
                comp: mobile ? "v-bottom-sheet" : "v-menu",
                props: {
                "close-on-content-click": false,
                "nudge-left": 62.5,
                },
            };
        },*/
        getTitleDate: {
            get() {
                return new Date(this.title).toISOString().substr(0, 10);
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        getViewTitle() {
            if (!this.title) return null;
            return moment(this.title).format("MMM YYYY");
        },
    },
    mounted() {
        this.getCalendarEvents();
    },
};
</script>
